import store from '@/store'
import useAuth from '@/utils/useAuth'

export default function useResources() {
  const { getMe } = useAuth()
  const loadResources = async () => {
    if (Object.keys(store.state.dataset).length) return

    store.commit('setStateProps', { prop: 'isLoading', value: true })

    await Promise.all([
      getMe(),
      store.dispatch('dataset/fetchDataset'),
      store.dispatch('schemas/getSchemas'),
    ])

    store.commit('setStateProps', { prop: 'isLoading', value: false })
  }

  return {
    loadResources,
  }
}
